export function redirectTarget(): 'boardstats' | 'accounts' | null {
	const params = new URLSearchParams(window.location.search)
	const target = params.get('redirect')
	if (target === 'boardstats' || target === 'accounts') {
		return target
	}
	return null
}
